module.exports = __webpack_public_path__ + "assets/img/vemproapp_generica_restaurante_story.843c3b9a.png";